import { IBaseMigrationStaffer } from '../../../interfaces';
import { StaffToUserMappingHandler } from '../../../mappings/staff-to-user';
import {
  IOasisProvider,
  OasisProvider,
  ProviderSourceEntity,
} from '../../source/entities/providers';

export class OasisStaffToUserMappingHandler extends StaffToUserMappingHandler<
  OasisProvider,
  ProviderSourceEntity
> {
  override sourceEntity = new ProviderSourceEntity();
  translateFn = (record: IOasisProvider): IBaseMigrationStaffer => {
    return {
      id: record.id,
      name: record.name,
      providerNo: record.providerNumber,
    };
  };
}
